import { render, staticRenderFns } from "./CheckField.vue?vue&type=template&id=b2c24284&"
import script from "./CheckField.vue?vue&type=script&lang=ts&"
export * from "./CheckField.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports